import api from "./api-service";

const update = (onboarding) => {
  return api().post("/onboarding", onboarding);
};

export { update };
